<template>
    <div class="d-md-none d-print-none bg-light pt-4">

        <div class="header ml-4">
            <img class="calque-1-icon" alt="" src="@/assets/images/logo.png" />
            <div class="nayzak-everyone-in">La mode pour tous</div>
        </div>


        <div class="m-4">
            <div class="elementsdropdown-mobile" @click="showFooterShop = !showFooterShop; showFooterInfo = false, showFooterHA = false;">
                <div class="titleicon ">
                    <div class="product text-dark">Shop</div>
                </div>
                <img class="iconchevron-down" alt="" src="@/assets/images/chevron-down.png" />
            </div>

            <!-- Shop links -->
            <div v-if="showFooterShop" >
                <footershop/>
            </div>

            <div class="elementsdropdown-mobile" @click="showFooterInfo = !showFooterInfo; showFooterShop = false, showFooterHA = false;">
                <div class="titleicon">
                    <div class="product text-dark">Informations</div>
                </div>
                <img class="iconchevron-down" alt="" src="@/assets/images/chevron-down.png" />
            </div>

            <!-- Informations links -->
            <div v-if="showFooterInfo" >
                <footerinfo/>
            </div>

            <div class="elementsdropdown-mobile " @click="showFooterHA = !showFooterHA; showFooterInfo = false, showFooterShop = false;">
                <div class="titleicon">
                    <div class="product text-dark">HA</div>
                </div>
                <img class="iconchevron-down" alt="" src="@/assets/images/chevron-down.png" />
            </div>

            <!-- HA links -->
            <div v-if="showFooterHA" >
                <footerha/>
            </div>
        </div>


        <div class="container mb-3">
            <footerregion/>
            <!-- <img class="mr-1" alt="" src="@/assets/images/tunisia-flag.svg" />
            <div class="">Français</div>
            <img class="mr-1" alt="" src="@/assets/images/chevron-down.png" />
            <strong>
                <div style="text-decoration: underline;">TND</div>
            </strong>
            <img alt="" src="@/assets/images/arrow-right.svg" /> -->
        </div>

        <div class="container pt-2 mb-3">
            <footersocial/>
        </div>

        <div class="container pb-0">
            <span class="nayzak">© {{ new Date().getFullYear() }} HA Copyright</span>
        </div>

        <div class="container pb-3">
            <a href="http://www.amiral.io" class="text-secondary mt-2" style="color:#92B9B1" target="_blank">powered by Amiral - INCENDO</a>
        </div>


    </div>
</template>

<script>

import footershop from "@/components/footer-shop.vue"
import footerinfo from "@/components/footer-info.vue"
import footerha from "@/components/footer-ha.vue"
import footersocial from "@/components/footer-social.vue"
import footerregion from "@/components/footer-region.vue"


export default ({
    name: "MobileFooter",

    components: {
        footershop, footerinfo, footerha, footersocial, footerregion
    },

    data() {
        return {
            showFooterShop: false,
            showFooterInfo: false,
            showFooterHA: false,
        }
    },
})



</script>

<style scoped>
.product {
    flex: 1;
    position: relative;
    line-height: 24px;
    font-weight: 500;
}

.titleicon {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.iconchevron-down {
    position: relative;
    width: 20px;
    height: 20px;
}

.elementsdropdown-mobile {
    width: 100%;
    position: relative;
    border-bottom: 1px solid #cbcbcb;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0px;
    gap: 24px;
    text-align: left;
    font-size: 14px;
    color: #3e3e59;
    font-family: 'Space Grotesk';
}

.calque-1-icon {
    position: relative;
    width: 30px;
    height: 26.03px;
    overflow: hidden;
    flex-shrink: 0;
}

.nayzak-everyone-in {
    align-self: stretch;
    position: relative;
    line-height: 22px;
}

.header {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;
    text-align: left;
    font-size: 14px;
    color: #3e3e59;
    font-family: Inter;
}


.container {
    display: flex;
    justify-content: center;
    align-items: center;

}

.icon {
    margin-right: 5px;
}

.icon:last-child {
    margin-right: 0;
}

.nayzak {
    position: relative;
    font-size: 12px;
    line-height: 20px;
    font-family: Inter;
    color: #3e3e59;
    text-align: center;
}
</style>
